/**
 * `WarningData` describes the state of the warning message that is displayed
 * if a test is using time by is not advancing the `TestClock`. The possible
 * states are `Start` if a test has not used time, `Pending` if a test has
 * used time but has not adjusted the `TestClock`, and `Done` if a test has
 * adjusted the `TestClock` or the warning message has already been displayed.
 *
 * @internal
 */

/** @internal */
const OP_WARNING_DATA_START = "Start";

/** @internal */

/** @internal */
const OP_WARNING_DATA_PENDING = "Pending";

/** @internal */

/** @internal */
const OP_WARNING_DATA_DONE = "Done";

/** @internal */

/** @internal */

/** @internal */

/** @internal */

/**
 * State indicating that a test has not used time.
 *
 * @internal
 */
const start = {
  _tag: OP_WARNING_DATA_START
};

/**
 * State indicating that a test has used time but has not adjusted the
 * `TestClock` with a reference to the fiber that will display the warning
 * message.
 *
 * @internal
 */
const pending = fiber => {
  return {
    _tag: OP_WARNING_DATA_PENDING,
    fiber
  };
};

/**
 * State indicating that a test has used time or the warning message has
 * already been displayed.
 *
 * @internal
 */
const done = {
  _tag: OP_WARNING_DATA_DONE
};

/** @internal */
const isStart = self => {
  return self._tag === OP_WARNING_DATA_START;
};

/** @internal */
const isPending = self => {
  return self._tag === OP_WARNING_DATA_PENDING;
};

export { OP_WARNING_DATA_DONE, OP_WARNING_DATA_PENDING, OP_WARNING_DATA_START, done, isPending, isStart, pending, start };
